import { Icon, IconProps } from "@chakra-ui/react";
import React from "react";

export const GemIcon = (props: IconProps): JSX.Element => (
  <Icon viewBox="0 0 42 28" {...props}>
    <g>
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.2779 18.6666L20.9671 9.33336L30.2779 0V18.6666ZM2.3457 9.33336L11.6565 0H30.2779L39.5887 9.33336L30.2779 18.6666L20.9671 28L2.3457 9.33336Z"
        fill="currentColor"
      />
    </g>
  </Icon>
);
